export default function AboutLawyer() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src="https://static.readdy.ai/image/97c320206ed08475f986f4f05d477848/5a6a5480219dadc71ff06553c0ed212f.webp" 
                  alt="Logo Lino García Abogados" 
                  className="w-16 h-16"
                />
                <div>
                  <h2 className="text-4xl font-bold text-gray-900">
                    Abogado Lino García
                  </h2>
                  <p className="text-xl text-blue-600 font-semibold">
                    Especialista en Migración y Extranjería
                  </p>
                </div>
              </div>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-shield-check-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">Abogado Colegiado ICAM Nº 138.891</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-award-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">15+ años en Derecho Migratorio y Extranjería</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-user-star-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">Especialista en casos complejos y perfiles técnicos</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">+1397 visados aprobados</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-star-fill text-2xl text-yellow-500 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">100% aprobaciones en visados de Nómada Digital</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-money-dollar-circle-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">0% sorpresas en costos</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-graduation-cap-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">Máster + Experiencia internacional</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-team-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">+500 profesionales remotos asesorados</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-time-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg font-semibold text-gray-900">Tiempo medio de respuesta: 24 horas</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <a 
                  href="#consulta" 
                  className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Reservar Consulta
                </a>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <img 
                src="https://static.readdy.ai/image/97c320206ed08475f986f4f05d477848/81887972dc1758ae9670a25d955b6449.png" 
                alt="Abogado Lino García - Especialista en Extranjería"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
